var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Top(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5459 11.2959C19.4414 11.4008 19.3172 11.484 19.1804 11.5408C19.0437 11.5976 18.8971 11.6268 18.749 11.6268C18.601 11.6268 18.4543 11.5976 18.3176 11.5408C18.1809 11.484 18.0567 11.4008 17.9521 11.2959L13.125 6.46876V20.25C13.125 20.5484 13.0064 20.8345 12.7955 21.0455C12.5845 21.2565 12.2983 21.375 12 21.375C11.7016 21.375 11.4154 21.2565 11.2045 21.0455C10.9935 20.8345 10.875 20.5484 10.875 20.25V6.46876L6.0459 11.2959C5.83455 11.5073 5.54791 11.626 5.24902 11.626C4.95014 11.626 4.66349 11.5073 4.45215 11.2959C4.2408 11.0846 4.12207 10.798 4.12207 10.4991C4.12207 10.2002 4.2408 9.91354 4.45215 9.7022L11.2021 2.95219C11.3067 2.84731 11.4309 2.7641 11.5676 2.70732C11.7043 2.65054 11.851 2.62131 11.999 2.62131C12.1471 2.62131 12.2937 2.65054 12.4304 2.70732C12.5672 2.7641 12.6914 2.84731 12.7959 2.95219L19.5459 9.7022C19.6508 9.80671 19.734 9.9309 19.7908 10.0676C19.8476 10.2044 19.8768 10.351 19.8768 10.4991C19.8768 10.6471 19.8476 10.7937 19.7908 10.9305C19.734 11.0672 19.6508 11.1914 19.5459 11.2959Z",
    fill: "#6B7380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Top);
export default __webpack_public_path__ + "static/media/24_top.fbcf8d2aef9b2a17a146ce86c92260a7.svg";
export { ForwardRef as ReactComponent };